var icon_button_default = {
  "audioIconButton": "eP6Tg"
};
export {
  icon_button_default as default
};
//# sourceMappingURL=icon-button-scss.js.map
